import { Rating, type Grade } from 'ts-fsrs';
import { cn } from '@/shared/lib/utils';
import type { IntervalPreview } from '../lib/scheduling';

const RATING_LABELS: Record<Grade, string> = {
  [Rating.Again]: 'Again',
  [Rating.Hard]: 'Hard',
  [Rating.Good]: 'Good',
  [Rating.Easy]: 'Easy',
};

function formatDays(days: number): string {
  if (days < 1) return '<1d';
  if (days >= 365) return `${Math.round(days / 365)}y`;
  if (days >= 30) return `${Math.round(days / 30)}mo`;
  return `${days}d`;
}

interface RatingPanelProps {
  intervals: IntervalPreview[];
  onRate: (rating: Grade) => void;
  disabled?: boolean;
}

export function RatingPanel({ intervals, onRate, disabled }: RatingPanelProps) {
  return (
    <div className="flex gap-2">
      {intervals.map(({ rating, days }) => (
        <button
          type="button"
          key={rating}
          disabled={disabled}
          className={cn(
            'flex-1 flex flex-col items-center gap-1.5 py-3.5',
            'rounded-xl bg-accent/40',
            'text-foreground/80',
            'hover:text-foreground hover:bg-accent',
            'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
            'active:scale-[0.97]',
            'transition-all cursor-pointer',
            'disabled:opacity-40 disabled:pointer-events-none',
          )}
          onClick={() => onRate(rating)}
        >
          <span className="text-sm font-medium leading-none">
            {RATING_LABELS[rating]}
          </span>
          <span className="text-[11px] leading-none text-muted-foreground">
            {formatDays(days)}
          </span>
        </button>
      ))}
    </div>
  );
}
